import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trackBtnClick, trackPageView } from "@/lib/helper";
import { useRecoilValue } from "recoil";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import BorderImg from "@/assets/images/border-box.png";
import BlueTorch from "@/assets/images/blue-torch.svg";
import "./custom.css";

export default function NewUserContent({ showTorch = false }) {
  const userData = useRecoilValue(userDataAtom);
  const navigate = useNavigate();

  const navigateToLink = () => {
    const currentStage = userData.currentStage;
    const dealStage = userData.dealStage;
    console.log(dealStage, "leadStage");

    switch (currentStage) {
      case "BASIC_DETAILS":
        return "about";
      case "RENTING_STATUS":
        return "renting-status";
      case "CHECK_ELIGIBILITY":
        return "eligibility-check";
      case "ADD_LANDLORD":
        return "steps";
      case "ADD_PROPERTY":
        return "rent-details";
      default:
        if (dealStage === "ONBOARDING_INIT") return "onboarding";
        break;
    }
  };

  return (
    <div
      className={`flex flex-col h-full w-full justify-evenly  ${
        showTorch ? "" : "py-2 sm:py-8"
      } items-center text-center`}
    >
      {userData.isEligible !== null ? (
        <div className="relative flex flex-col gap-4 items-center p-4 overflow-hidden">
          {/* Gradient Border */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              zIndex: 1,
              background: `
            linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) top,
            linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) bottom,
  linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) right,
  linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) left
            `,
              backgroundSize: "100% 0.8px, 100% 0.8px, 0.8px 100%, 0.8px 100%",
              backgroundRepeat: "no-repeat",
            }}
          />

          {/* Background Image */}
          <div
            className="absolute inset-0 pointer-events-none -ml-4 opacity-40"
            style={{
              zIndex: 0,
              backgroundImage: `url(${BorderImg})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />

          {/* Content */}
          <div className="flex flex-col relative z-10 gap-8 items-center justify-center">
            <div className="flex flex-col gap-2">
              <p
                className={`${
                  showTorch ? "text-base" : "text-base"
                } font-medium se:px-6 sm:px-8 text-center`}
              >
                Get ZERO Security Deposit to your new home
              </p>
            </div>

            <div className="w-fit inline-block p-0 bg-gradient-to-br from-[#010101] via-[#EEEEEE] to-[#010101] rounded-full mt-2">
              <button
                onClick={() => {
                  trackBtnClick(
                    "Start Here",
                    "Home Page",
                    "Property and Landlord Details Flow"
                  );
                  navigate(navigateToLink());
                }}
                className="gap-2 bg-gradient-to-r from-blue-800 to-blue-600 text-white font-medium se:px-6 se:py-2 text-xs flex items-center flex-row rounded-full relative overflow-hidden transition-transform hover:scale-105 duration-300"
              >
                <span className="z-10 min-w-max"> Get Started </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-move-right z-10"
                >
                  <path d="M18 8L22 12L18 16" />
                  <path d="M2 12H22" />
                </svg>
                <span className="shine-bg"></span>
              </button>
            </div>

            {showTorch && <img src={BlueTorch} alt="" className="max-h-24" />}
          </div>
        </div>
      ) : (
        <div className="relative flex flex-col gap-4 items-center p-4 overflow-hidden">
          {/* Gradient Border */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              zIndex: 1,
              background: `
            linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) top,
            linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) bottom,
  linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) right,
  linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0)) left
            `,
              backgroundSize: "100% 0.8px, 100% 0.8px, 0.8px 100%, 0.8px 100%",
              backgroundRepeat: "no-repeat",
            }}
          />

          {/* Background Image */}
          <div
            className="absolute inset-0 pointer-events-none -ml-4 opacity-40"
            style={{
              zIndex: 0,
              backgroundImage: `url(${BorderImg})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />

          {/* Content */}
          <div className="flex flex-col relative z-10 gap-2 items-center justify-center">
            <div className="flex flex-col gap-2">
              <p className="font-semibold bg-shiny-gray bg-clip-text text-[#005fe4] text-xs">
                YOU ARE NOT ELIGIBLE FOR CLUB YET
              </p>
              <p
                className={`${
                  showTorch ? "text-base" : "text-lg"
                } font-medium px-6`}
              >
                Check your eligibility now!
              </p>
            </div>
            <div className="w-fit inline-block p-0 bg-gradient-to-br from-[#010101] via-[#EEEEEE] to-[#010101] mt-4 rounded-full">
              <button
                onClick={() => {
                  trackBtnClick("Check Here", "Home Page", "Check Eligibilty");
                  navigate(navigateToLink());
                }}
                className="bg-gradient-to-r from-blue-800 to-blue-600 text-white font-medium se:px-6 se:py-3 text-xs flex items-center flex-row rounded-full relative overflow-hidden transition-transform hover:scale-105 duration-300"
              >
                <span className="z-10 min-w-max"> Check Here </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-4 h-4 ml-2 z-10"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
                <span className="shine-bg"></span>
              </button>
            </div>
            {showTorch && <img src={BlueTorch} alt="" className="max-h-24" />}
          </div>
        </div>
      )}
    </div>
  );
}
